import { DetailField, DetailSection } from '../common'

import { AssignmentRendererProps } from './AssignmentRenderer.types'
import { EventTime } from 'components/common/EventTime'
import { FC } from 'react'
import Stack from '@mui/material/Stack'
import { useTimezone } from 'components/contexts/timezone.context'
import { useTranslation } from 'react-i18next'
import { ProductListingSection } from './shared/ProductListingSection.component'

/**
 * Fallback renderer for assignment types without a specific renderer.
 * Shows basic assignment info from AssignmentDTOBase fields.
 */
export const DefaultAssignmentRenderer: FC<AssignmentRendererProps> = ({ assignment }) => {
  const { t } = useTranslation(['gallery', 'product'])
  const { userTimezone } = useTimezone()

  return (
    <Stack gap="0.8rem">

      <ProductListingSection products={assignment.products} />

      {!!assignment.shootingStartDateTime &&
        <DetailSection title={t('gallery:assignment_details.schedule')}>
          <EventTime
            eventStart={assignment.shootingStartDateTime}
            eventTimezone={assignment.timezone}
            userTimezone={userTimezone}
            minDuration={assignment.timeOnSiteMin}
            maxDuration={assignment.timeOnSiteMax}
          />
        </DetailSection>
      }

    </Stack>
  )
}
